import { render, staticRenderFns } from "./HbMediaViewer.vue?vue&type=template&id=bebefcb8&scoped=true&"
import script from "./HbMediaViewer.vue?vue&type=script&lang=js&"
export * from "./HbMediaViewer.vue?vue&type=script&lang=js&"
import style0 from "./HbMediaViewer.vue?vue&type=style&index=0&id=bebefcb8&prod&scoped=true&lang=css&"
import style1 from "./HbMediaViewer.vue?vue&type=style&index=1&id=bebefcb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebefcb8",
  null
  
)

export default component.exports